/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { css } from 'styled-components';
/* stylelint-disable plugin/no-z-index */

const stacking = {
  level0: css`
    z-index: 0;
  `,
  level1: css`
    z-index: 1;
  `,
  level2: css`
    z-index: 2;
  `,
  level3: css`
    z-index: 3;
  `,
  level4: css`
    z-index: 4;
  `,
  level5: css`
    z-index: 5;
  `
};

export default stacking;
